import RestClient from './restClient';

export default class FeedbackRepository extends RestClient {
  constructor() {
    super('/v1/feedback');
  }

  /**
   * Submit feedback to the server
   * @param {FormData} formData - Form data containing feedback
   * @returns {Promise} API response
   */
  async submit(formData) {
    return this.post('', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}
